import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'

import lhUI from 'lianghang-ui'
Vue.use(lhUI);

Vue.config.productionTip = false

router.beforeEach((to,from,next)=>{
  // console.log(to);
  if(to.meta.title){
    document.title=to.meta.title;
  }
  next();
})

const vue=new Vue({
  render: h => h(App),
  router
});

vue.$mount('#app')

export default vue;


